module.exports = __webpack_public_path__ + "static/media/attach_24.55557feb.svg";